import React from 'react';
import { Info, CheckCircle2 } from 'lucide-react';
import type { DiagnosticCount } from './types';

// ── Diagnostics Summary ───────────────────────────────────────────────────────

export default function DiagnosticsBar({ placeholder, missing }: DiagnosticCount) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: '0.75rem',
      padding: '0.375rem 0.75rem',
      background: 'var(--glass-bg-card)',
      borderBottom: '1px solid rgba(255,255,255,0.10)',
      fontSize: 11, flexShrink: 0, flexWrap: 'wrap',
    }}>
      <span style={{ fontWeight: 600, color: 'var(--color-text-muted)', marginRight: '0.25rem' }}>
        <Info size={11} style={{ verticalAlign: 'middle', marginRight: 3 }} />
        Variabili:
      </span>
      <span style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
        <span style={{ background: 'var(--color-primary-highlight)', color: 'var(--color-primary)', padding: '1px 5px', borderRadius: 3, fontSize: 10 }}>
          blu
        </span>
        <span style={{ color: 'var(--color-text-muted)' }}>{placeholder} placeholder</span>
      </span>
      <span style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
        <span style={{ background: 'var(--color-warning-highlight)', color: 'var(--color-warning)', padding: '1px 5px', borderRadius: 3, fontSize: 10 }}>
          arancio
        </span>
        <span style={{ color: 'var(--color-text-muted)' }}>personalizzate</span>
      </span>
      {missing > 0 && (
        <span style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
          <span style={{ background: 'var(--color-error-highlight)', color: 'var(--color-error)', padding: '1px 5px', borderRadius: 3, fontSize: 10 }}>
            rosso
          </span>
          <span style={{ color: 'var(--color-danger)', fontWeight: 600 }}>{missing} non risolte</span>
        </span>
      )}
      {missing === 0 && placeholder > 0 && (
        <span style={{ color: 'var(--color-success)', display: 'flex', alignItems: 'center', gap: 3 }}>
          <CheckCircle2 size={11} /> Tutte le variabili note
        </span>
      )}
      <span style={{ color: 'var(--color-text-faint)', marginLeft: 'auto' }}>
        Seleziona evento per dati reali
      </span>
    </div>
  );
}
